import { styled } from "@mui/material";

export const FinishStepRoot = styled("div")`
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    height: 100%;
    gap: 12px;
    box-sizing: border-box;
    padding-bottom: 120px;
`;

export default FinishStepRoot;
